import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class CashBackSchemeFilter extends Component {
    state = {
        schemeLists:[],
        schemeValue: '',
        isSchemeLoading: true
    };
    componentDidMount(){
        this._get_scheme(this.props.start_date,this.props.end_date);
    }
    resetScheme()
    {
        this.setState({
            schemeValue: [],
        })
    }
    _get_scheme(start_date, end_date){
        this.setState({
            schemeLists:[],
            schemeValue: [],
            isSchemeLoading: true
        })
        axios.post(config.get('API_URL')+'/reports/contactless-cardtype/',{
                yestSend: start_date,
                todSend: end_date,
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            this.setState({
                schemeLists:[]
            })
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((card_type, index) => {
                    this.state.schemeLists.push({value: card_type.card_type, label: card_type.card_type})
                });
            }
            this.setState({
                isSchemeLoading: false
            })
        });

    }


    changeScheme(optionSelected){
        let value='';
        let schemeArray = [];
        if(optionSelected.length < 1){
            value = null;
            schemeArray='';
        }
        else{
            optionSelected.map((mids, i) => {
                schemeArray.push(mids.value)
                var index = this.state.schemeLists.findIndex(obj => obj.value==mids.value);
                this.state.schemeLists.move(index,0).join(',');
            });
        }
        this.props.onSelectScheme(optionSelected, schemeArray);
        this.setState({
            schemeValue:optionSelected,
        });
    }
    render() {

        return (
            <ReactMultiSelectCheckboxes name="scheme"
                isMulti
                value={this.state.schemeValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeScheme.bind(this)}
                options={this.state.schemeLists}
                placeholderButtonLabel="Select [Scheme]"
                isLoading={this.state.isSchemeLoading}
            />
        );

    }
}
export default CashBackSchemeFilter;